export const exists = <T>(v: T): v is T => v !== undefined && v !== null;
